import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "23",
      height: "21",
      x: "3.5",
      y: "5.5",
      rx: "2"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M10 3.5v4m10-4v4M3.5 11h23M7.5 16h7M12 21h10.5" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }